<button
  class="segment-element flex items-center justify-center"
  [disabled]="disabled"
  [class.segment-element-disabled]="disabled"
  [class.segment-element-active]="active">
  <ng-content></ng-content>
</button>
